import React, { useState, useEffect, useMemo, useCallback } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'
import { FormSpy } from 'react-final-form'

/**
 * pls no #pranger. crasht sonst wenn das customs field removed wird.
 */
const ImporterExporterHandler = (props) => {
  const { importer, setImporter, exporter, setExporter, isOld } = props

  const onUpdate = (values) => {
    const exporter1 = lodash.get(values, isOld ? 'pickupAddress' : 'pickup.address.name1')
    const importer1 = lodash.get(values, isOld ? 'customsAddress.name1' : 'customs.address.name1')
    const importer2 = lodash.get(values, isOld ? 'deliveryAddress.name1' : 'delivery.address.name1')
    const newImporter = importer1 || importer2 || i18n.t('importer', 'Importeur')
    const newExporter = exporter1 || i18n.t('exporter', 'Exporteur')
    if (!lodash.isEqual(importer, newImporter)) {
      setImporter(newImporter)
    }
    if (!lodash.isEqual(exporter, newExporter)) {
      setExporter(newExporter)
    }
  }

  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => {
        onUpdate(values)
        return null
      }}
    </FormSpy>
  )
}

export default ImporterExporterHandler
